__turbopack_context__.v({
  "buttonWrapper": "EmptyTemplatesState-module__a9VIdW__buttonWrapper",
  "emptyTableDisplay": "EmptyTemplatesState-module__a9VIdW__emptyTableDisplay",
  "gridWrapper": "EmptyTemplatesState-module__a9VIdW__gridWrapper",
  "iconWrapper": "EmptyTemplatesState-module__a9VIdW__iconWrapper",
  "textWrapper": "EmptyTemplatesState-module__a9VIdW__textWrapper",
});
